import { useRouter } from 'next/router';
import { SyntheticEvent } from 'react';

export function useAboutPage() {
  const router = useRouter();
  const onClickPlay = (e: SyntheticEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const url = e.currentTarget.dataset.url;
    window.open(url);
  };

  return {
    state: {
      isJa: router.locale === 'ja',
    },
    actions: {
      onClickPlay,
    },
  };
}
